module.exports = __webpack_public_path__ + "static/media/magellan-horizontal.5e9bfae1.jpg";